import cn from 'classnames';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useDebounce } from 'usehooks-ts';
import ROUTES from '../../../layout/routes';
import style from '../HeaderButtons.module.scss';
import { useHeaderColorScheme } from '../hooks/useIconWrapperStyle';

const DropDownFlats = ({ headerColorScheme, onClick }) => {
  const [toggleDropDown, setToggleDropDown] = useState(false);
  const debouncedToggleDropDown = useDebounce(toggleDropDown, 60); // это нужно для того, чтобы при попадании в обасть паддинга у нас не прыгал со скоростью света класс active
  const headerBtnStyle = useHeaderColorScheme(headerColorScheme);
  const clickButton = () => {
    setToggleDropDown(!toggleDropDown);
    onClick();
  };
  return (
    <div
      onMouseOver={() => setToggleDropDown(true)}
      onMouseLeave={() => setToggleDropDown(false)}
      className={style.dropDownContainer}
      onFocus={() => {
        return null;
      }}
    >
      <NavLink to={ROUTES.flats.visual.root}>
        <button
          onClick={() => clickButton()}
          className={cn(headerBtnStyle, style.headerDropDownButton, debouncedToggleDropDown ? style.active : null)}
        >
          <span>Визуальный выбор</span>
        </button>
      </NavLink>
    </div>
  );
};

export default DropDownFlats;
